import { render } from "./IndexJournaux.vue?vue&type=template&id=351729bb"
import script from "./IndexJournaux.vue?vue&type=script&lang=js"
export * from "./IndexJournaux.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__